(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mmw-shell"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
 const button=event.target.closest('button');if(!button)return;
 if(button.matches('.menu-toggle')){const opened=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!opened));document.querySelector('.mobile-nav').hidden=opened;}
 if(button.hasAttribute('data-gallery-src')){const gallery=button.closest('.product-gallery');const image=gallery.querySelector('.selected-product-image');image.src=button.dataset.gallerySrc;image.removeAttribute('srcset');image.alt=button.querySelector('img').alt;gallery.querySelectorAll('[data-gallery-src]').forEach(b=>{b.classList.toggle('active',b===button);b.setAttribute('aria-pressed',String(b===button));});}
 if(button.hasAttribute('data-concept-src')){const card=button.closest('.concept-card');card.querySelector('.selected-product-image').src=button.dataset.conceptSrc;card.querySelectorAll('[data-concept-src]').forEach(b=>{b.classList.toggle('active',b===button);b.setAttribute('aria-pressed',String(b===button));});}
});
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;const menu=document.querySelector('.mobile-nav');if(menu&&!menu.hidden){menu.hidden=true;const button=document.querySelector('.menu-toggle');button.setAttribute('aria-expanded','false');button.focus();}});
document.addEventListener('change',function(event){
 if(event.target.matches('[data-sort]'))event.target.closest('form').requestSubmit();
 if(event.target.matches('[data-variant-picker]')){const option=event.target.selectedOptions[0];const info=event.target.closest('.product-info');info.querySelector('[data-product-price]').textContent=option.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);}
});


  } catch(e) { console.error(e); }
})();
})();
